import React from 'react';
import ReactDOM from 'react-dom/client';
import {
	createHashRouter,
	LoaderFunctionArgs,
	RouterProvider,
} from 'react-router-dom';
import './styles/index.scss';
import App from './App';
// import reportWebVitals from './reportWebVitals';
import Exersizes from './routes/exersizes/exersizes';

import Quiz from './routes/quiz/quiz';

import RootBoundary from './components/ErrorBoundaries/RootBoundary/RootBoundary';
import Summary from './routes/summary/summary';
import { ReactPressVars } from './types';
//@ts-ignore
import $ from 'jquery';

import MyData from './routes/mydata/mydata';

const rootEl = document.getElementById('root') as HTMLElement;
const root = ReactDOM.createRoot(
	document.getElementById('root') as HTMLElement
);
const origin = window.location.origin;
const isDev = origin.includes('localhost');

declare global {
	interface Window {
		reactPress: ReactPressVars;
	}
}

const wpdata = window.reactPress ?? {
	user: {
		ID: 1,
		allcaps: {},
		caps: {},
		roles: [],
	},
	api: {
		nonce: '',
		rest_url: 'http://adap.local',
	},
};

const exersizesLoader = async ({ params }: LoaderFunctionArgs) => {
	return $.ajax({
		url: `/wp-json/adp-app/get-products-with-cats/${wpdata.user.ID}`,
		method: 'GET',
		// @ts-ignore
		beforeSend: function (xhr) {
			// @ts-ignore
			xhr.setRequestHeader('X-WP-Nonce', wpdata.api.nonce);
		},
	}).done(function (response: any) {
		return response;
	});
};
const exersizesLoaderDev = async ({ params }: LoaderFunctionArgs) => {
	return $.ajax({
		url: `http://adap.local/wp-json/adp-app/get-products-with-cats/${wpdata.user.ID}`,
		method: 'GET',
		// header: {
		// 	'Access-Control-Allow-Origin': 'http://adap.local',
		// 	'Access-Control-Allow-Credentials': 'true',
		// },
	}).done(function (response: any) {
		return response;
	});
};
const quizLoader = async ({ params }: LoaderFunctionArgs) => {
	if (params.catIDs === undefined) {
		throw new Error('QL:1');
	}
	const categoryArr = params.catIDs.split('_');
	categoryArr.shift();
	if (categoryArr === undefined || categoryArr.length === 0) {
		throw new Error('QL:2');
	}
	const categories = new Array<{
		id: string;
		subcatIDs: string[] | undefined;
	}>();
	categoryArr.forEach((catParams) => {
		let catId: string;
		let subcatIDs;
		const cat_subcats = catParams.split('-');
		catId = cat_subcats[0].replace('c:', '') as string;
		if (cat_subcats.length === 2) {
			subcatIDs = cat_subcats[1].replace('sc:', '').split(',');
		}
		const newCat = { id: catId, subcatIDs: subcatIDs };
		categories.push(newCat);
	});

	return $.ajax({
		url:
			wpdata.user.ID > 0
				? '/wp-json/adp-app/get-quiz-questions/'
				: '/wp-json/adp-app/get-demo-questions/',
		method: 'POST',
		//@ts-ignore
		beforeSend: function (xhr) {
			// @ts-ignore
			xhr.setRequestHeader('X-WP-Nonce', wpdata.api.nonce);
		},
		data: JSON.stringify({
			uid: wpdata.user.ID,
			pid: params.productID,
			// category_ids: params?.catIDs?.split(',') ?? [],
			categories: categories,
		}),
	}).done(function (response: any) {
		return response;
	});
};
const quizLoaderDev = async ({ params }: LoaderFunctionArgs) => {
	if (params.catIDs === undefined) {
		throw new Error('QL:1');
	}
	const categoryArr = params.catIDs.split('_');
	categoryArr.shift();
	if (categoryArr === undefined || categoryArr.length === 0) {
		throw new Error('QL:2');
	}
	const categories = new Array<{
		id: string;
		subcatIDs: string[] | undefined;
	}>();
	categoryArr.forEach((catParams) => {
		let catId: string;
		let subcatIDs;
		const cat_subcats = catParams.split('-');
		catId = cat_subcats[0].replace('c:', '') as string;
		if (cat_subcats.length === 2) {
			subcatIDs = cat_subcats[1].replace('sc:', '').split(',');
		}
		const newCat = { id: catId, subcatIDs: subcatIDs };
		categories.push(newCat);
	});

	return $.ajax({
		url:
			parseInt(params.productID ?? '0') !== 0
				? 'http://adap.local/wp-json/adp-app/get-quiz-questions/'
				: 'http://adap.local/wp-json/adp-app/get-demo-questions/',
		method: 'POST',
		data: JSON.stringify({
			uid: 1,
			pid: params.productID,
			// category_ids: params?.catIDs?.split(',') ?? [],
			categories: categories,
		}),
	}).done(function (response: any) {
		return response;
	});
};
const mydataLoader = async ({ params }: LoaderFunctionArgs) => {
	if (wpdata.user.ID === 0) {
		return {};
	}
	return $.ajax({
		url: `/wp-json/adp-app/get-mydata-data/${wpdata.user.ID}`,
		method: 'GET',
		//@ts-ignore
		beforeSend: function (xhr) {
			// @ts-ignore
			xhr.setRequestHeader('X-WP-Nonce', wpdata.api.nonce);
		},
	}).done(function (response: any) {
		return response;
	});
};
const mydataLoaderDev = async ({ params }: LoaderFunctionArgs) => {
	if (wpdata.user.ID === 0) {
		return {};
	}
	return $.ajax({
		url: 'http://adap.local/wp-json/adp-app/get-mydata-data/1',
		method: 'GET',
	}).done(function (response: any) {
		return response;
	});
};

const router = createHashRouter([
	{
		path: '/',
		element: <App root={rootEl} wpdata={wpdata} />,
		errorElement: <RootBoundary />,

		children: [
			{
				path: 'exersizes',
				element: <Exersizes wpdata={wpdata} isDev={isDev} />,
				loader: isDev ? exersizesLoaderDev : exersizesLoader,
			},
			{
				path: 'summary',
				element: <Summary root={rootEl} wpdata={wpdata} />,
			},
			{
				path: 'mydata',
				element: <MyData root={rootEl} wpdata={wpdata} />,
				loader: isDev ? mydataLoaderDev : mydataLoader,
			},
			{
				path: 'quiz/:productID/:catIDs',
				element: <Quiz root={rootEl} wpdata={wpdata} isDev={isDev} />,
				loader: isDev ? quizLoaderDev : quizLoader,
			},

			{
				path: '*',
				element: (
					<main style={{ padding: '1rem' }}>
						<p>There's nothing here!!</p>
					</main>
				),
			},
		],
	},
]);
root.render(
	<React.StrictMode>
		<RouterProvider router={router} />
	</React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
